/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs */

const en_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Events to the bottom center of the video`)
};

const fr_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner les evenements en bas au centre de la video`)
};

const de_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionieren Sie die Ereignisse unten in der Mitte des Videos.`)
};

const it_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posiziona gli eventi al centro in basso del video`)
};

const ru_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разместите события в нижней центральной части видео.`)
};

const es_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colocar eventos en la parte inferior central del vídeo`)
};

const zh_cn2_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将事件定位到视频底部中心位置`)
};

const ja_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントをビデオの下部中央に配置する`)
};

const hi_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो के निचले केंद्र में इवेंट्स की स्थिति निर्धारित करें।`)
};

const pt_pt2_shortcut_keys_desc_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posicione os eventos na parte inferior central do vídeo.`)
};

/**
* | output |
* | --- |
* | "Position Events to the bottom center of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_bottom_center = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Bottom_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_cc_position_bottom_center(inputs)
	if (locale === "de") return de_shortcut_keys_desc_cc_position_bottom_center(inputs)
	if (locale === "it") return it_shortcut_keys_desc_cc_position_bottom_center(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_cc_position_bottom_center(inputs)
	if (locale === "es") return es_shortcut_keys_desc_cc_position_bottom_center(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_cc_position_bottom_center(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_cc_position_bottom_center(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_cc_position_bottom_center(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_cc_position_bottom_center(inputs)
	return en_shortcut_keys_desc_cc_position_bottom_center(inputs)
});